// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keys from "../utils/keys";
import { encryptAndStoreToken } from "../utils/tokenSecure";

export const signinApi = createApi({
  reducerPath: "signinApi",
  baseQuery: fetchBaseQuery({ baseUrl: keys.baseUrl }),
  endpoints: (builder) => ({
    signin: builder.mutation({
      query: (body) => ({
        url: "user/login",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        if (!response.error) {
          encryptAndStoreToken(response.AccessToken);
        }
        return response;
      },
    }),
    signup: builder.mutation({
      query: (body) => ({
        url: "user/signup",
        method: "POST",
        body: body,
      }),
      transformResponse: (response) => {
        return response;
      },
    }),
    googleSignup: builder.query({
      query: (params) => ({
        url: `user/google`,
        method: "GET",
        redirect: 'manual', // Prevent automatic redirect following
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    forgotPassword: builder.mutation({
      query: (body) => ({
        url: "user/forgot-password",
        method: "POST",
        body: body,
      }),
    }),
    resetPassword: builder.mutation({
      query: (body) => ({
        url: `user/confirm-forgot-password`,
        method: "POST",
        body: body,
      }),
    }),
    validateToken: builder.mutation({
      query: (body) => ({
        url: `user/verify-token`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});
export const {
  useSigninMutation,
  useSignupMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useValidateTokenMutation,
  useGoogleSignupQuery
} = signinApi;
